export const STRUCTURE_INSTRUCTIONS_LABEL = 'Structure, Format, and Vocabulary';
export const STRUCTURE_INSTRUCTIONS_SUBLABEL = 'Type structure or formatting instructions here';
